export const Harmony = {
    chainId: 1666600000,
    chainName: 'Harmony',
    isTestChain: false,
    isLocalChain: false,
    multicallAddress: '0xFE4980f62D708c2A84D3929859Ea226340759320',
    getExplorerAddressLink: (address) => `https://explorer.harmony.one/address/${address}`,
    getExplorerTransactionLink: (transactionHash) => `https://explorer.harmony.one/tx/${transactionHash}`,
};
export default { Harmony };
//# sourceMappingURL=harmony.js.map